module.exports = __webpack_public_path__ + "img/super-hero-4.d3e53e25.gif";